exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".togglit-table tbody tr {\n  cursor: move; }\n\n.togglit-table tbody tr:first-of-type .divider-content {\n  padding-top: 0; }\n\n.togglit-table tbody tr:first-of-type .divider {\n  border-radius: 0 0 3px 3px; }\n\n.divider-item + .divider-item ::ng-deep .divider-content {\n  padding-top: 0; }\n\n.tab-bar-buttons .oi-video {\n  font-size: 17px;\n  margin-left: 3px;\n  margin-top: -3px;\n  position: relative;\n  top: 2px; }\n\n.error {\n  margin-top: -19px;\n  font-size: 12px;\n  text-align: left;\n  margin-bottom: 3px;\n  font-style: italic; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/content-editor/content-editor.component.scss
// module id = ../../../../../src/app/shared/components/content-editor/content-editor.component.scss
// module chunks = 12